<template>
  <div>
    <div id="content">
      <video id="video" playsinline muted></video>
      <div id="click"></div>
    </div>
    <div id="adContainer">
      <div id="bottom" style="position: absolute; bottom: 0px">
        <progress value="0" max="-1" id="progress"></progress>
        <div id="sound"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  async created() {
    const script_links = [
      config.ima_endpoint + '/ima3.js',
    ];
    if(!config.ima_endpoint.includes('dev')){
      script_links.push(config.ima_endpoint +  "/ima3_dai.js")
    }

    await Promise.all(
      _.map(script_links, (script_link) => {
        return new Promise((resolve, reject) => {
          let script = document.createElement("script");
          script.type = "text/javascript";
          script.src = script_link;
          document.head.appendChild(script);
          script.addEventListener("load", (e) => {
            resolve();
          });
        });
      })
    );

    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = config.ima_endpoint + "/ucPlayer.js";
    document.head.appendChild(script);

    let style = document.createElement("link");
    style.rel = "stylesheet";
    style.href = config.ima_endpoint + "/ucPlayer.css";
    document.head.appendChild(style);
  },
};
</script>

<style></style>
